module.exports = __webpack_public_path__ + "static/img/5.6cf8751.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/zh/5.png
// module id = nlnK
// module chunks = 0